
    import { Vue, Component } from 'vue-property-decorator'
    import Layout from '../../common/components/layout/layout.vue'
    import Twofactor from '../components/twofactor.vue'
    import CommunicationPreferences from '../components/communicationPreferences.vue'
    import { mapState } from 'vuex'
    import { Language } from '@/app/license/entities/language.entity'
    import { Consumer } from '@/app/identity'

    @Component({
        components: { Layout, Twofactor, CommunicationPreferences },
        computed: {
            ...mapState('license', ['languages']),
            ...mapState('auth', ['consumer'])
        }
    })
    export default class Settings extends Vue {
        languages!: Language[]
        consumer!: Consumer
    }
